import React, { Component } from "react";
import PropTypes from "prop-types";
import DashboardApi from "../utils/api/dashboardApi";
import getPricingEstimate from "../utils/get-pricing-estimate";

export class CalculatingQuoteComponent extends Component {
  ga = null;

  loadingStyle = { width: "100%" };
  constructor(props) {
    super(props);
    const loader = props.loadingGif || "standard";

    let limage = "analyizing-loader.gif";

    switch (loader) {
      case "standard":
        limage = "analyizing-loader.gif";
        break;
      case "no-soil":
        limage = "analyizing-loader-no-soil.gif";
        this.loadingStyle = { maxHeight: 220 };
        break;
      case "pest-control":
        limage = "pest-control-loader.gif";
        break;
      default:
    }

    this.state = {
      loaderTimeoutFinished: false,
      callbackFinished: false,
      loaderImage: limage,
    };
  }

  componentDidMount() {
    // Skip API call if price blocks are already loaded
    // This prevents duplicate calls when the component remounts
    if (this.props.loadedPriceBlocks && this.props.priceBlocks?.length > 0) {
      const { setPriceBlocks, triggerNextStep } = this.props;
      setPriceBlocks(this.props.priceBlocks, () => {
        triggerNextStep({ value: "Opening Quote Now" });
      });
      return;
    }
    this.getQuotePriceBlocks();
  }

  async getQuotePriceBlocks() {
    const {
      selectedServices,
      answers,
      companyId,
      botId,
      adjustedLotSize,
      skipMeasurement = false,
      chatId,
      onboarding,
      preview,

      customerAddress,
      customerCity,
      customerZip,
      customerCounty,
      customerState,
      customerCountryCode,
      customerCountry,
    } = this.props;

    const estimateToSend = getPricingEstimate({
      estimate: adjustedLotSize,
      skipMeasurement,
    });
    const payload = {
      serviceTypes: selectedServices,
      companyId,
      quoteId: chatId,
      botId,
      estimate: estimateToSend,
      answers,

      street: customerAddress,
      city: customerCity,
      postalCode: customerZip,
      county: customerCounty,
      state: customerState,
      country: customerCountryCode || customerCountry,
    };

    try {
      const response = await DashboardApi.post(
        `/v1/rtp/quote/services${
          onboarding ? "?onboarding=true" : preview ? "?preview=true" : ""
        }`,
        payload,
      );
      const { data } = response;
      if (this.props.ga) {
        this.props.ga.send("event", "quote", "given", 1);
      }

      const { setPriceBlocks, triggerNextStep } = this.props;

      // Handle new response structure: { programs: [...], summary: {...}, config: {...} }
      // Also support legacy array response for backward compatibility
      const programs = Array.isArray(data) ? data : data.programs || [];
      const summary = data.summary || null;
      const config = data.config || null;

      const ontop = programs.filter((i) => i.alwaysOnTop);
      const notOnTop = programs.filter((i) => !i.alwaysOnTop);
      const all = [...ontop, ...notOnTop];

      // Pass summary and config to setPriceBlocks if available
      setPriceBlocks(
        all,
        () => {
          triggerNextStep({ value: "Opening Quote Now" });
        },
        summary,
        config,
      );
    } catch (error) {
      if (error?.response?.status === 404) {
        console.log("sqft too big or small from calculating component");
        this.props.bot.moveToStep("sqft-too-big");
      } else {
        console.log(error);
      }
    }
  }

  render() {
    return (
      <div
        style={{
          width: "80%",
          fontFamily: "'Open Sans', sans-serif",
          fontSize: 16,
          margin: "auto",
          paddingBottom: 50,
          textAlign: "center",
          minHeight: 200,
          color: "rgb(20, 126, 251)",
        }}
      >
        <img
          src={`/assets/images/${this.state.loaderImage}`}
          alt="calculating"
          style={this.loadingStyle}
        />
      </div>
    );
  }
}

CalculatingQuoteComponent.propTypes = {
  setPriceBlocks: PropTypes.func,
  skipMeasurement: PropTypes.bool,
};
